import React from 'react'

function PrivacyPolicy() {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>Privacy Policy for Stock and Inventory Management</h1>

      <h2>1. Introduction</h2>
      <p>
        Welcome to Inventory ERP. We respect your privacy and are committed to
        protecting the personal information of our users. This Privacy Policy explains how we collect, use, and
        safeguard your data when you use our multi-tenant Inventory ERP.
      </p>
      <p>By using our platform, you agree to the terms outlined in this Privacy Policy.</p>

      <h2>2. Information We Collect</h2>
      <ul>
        <li><strong>Account Information:</strong> Name, email, phone number, company details, and billing information.</li>
        <li><strong>Usage Data:</strong> IP address, login timestamps, device/browser details, and session activity.</li>
        <li><strong>Business Data:</strong> Stock levels, order details, production tracking, and purchase records entered by users.</li>
      </ul>

      <h2>3. How We Use Your Data</h2>
      <ul>
        <li><strong>Providing Services:</strong> To enable users to manage stock, orders, and production.</li>
        <li><strong>User Authentication:</strong> To ensure account security and prevent unauthorized access.</li>
        <li><strong>Analytics & Improvements:</strong> To improve our platform, user experience, and security.</li>
        <li><strong>Billing & Payments:</strong> To process subscriptions and issue invoices.</li>
        <li><strong>Compliance with Laws:</strong> To meet regulatory and legal obligations.</li>
      </ul>

      <h2>4. Data Sharing & Security</h2>
      <ul>
        <li><strong>Multi-Tenant Data Protection:</strong> Each client’s data remains isolated within the shared database.</li>
        <li><strong>No Unauthorized Sharing:</strong> We do not sell or share user data with third parties.</li>
        <li><strong>Encryption & Security:</strong> All data is encrypted and stored securely.</li>
        <li><strong>Data Access:</strong> Only authorized users from your organization can access your data.</li>
      </ul>

      <h2>5. User Rights & Data Retention</h2>
      <ul>
        <li><strong>Access & Control:</strong> Users can access, modify, or delete their data.</li>
        <li><strong>Account Termination:</strong> If you cancel your subscription, your data will be stored for [X] months before deletion.</li>
        <li><strong>Cookies & Tracking:</strong> We use cookies for authentication and analytics (users can opt out).</li>
      </ul>

      <h2>6. Changes to This Policy</h2>
      <p>We may update this Privacy Policy periodically. Users will be notified of major changes.</p>

      <h2>How We Handle Your Business Data and Alerts</h2>
      <p><strong>Contact Us:</strong> If you have any privacy concerns, email us at <a href="mailto:support@clearbiz.ai">support@clearbiz.ai</a></p>
    </div>
  )
}

export default PrivacyPolicy
